var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#2240CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4062 22.625C27.5002 22.625 25.9375 24.1877 25.9375 26.0938V46.9062C25.9375 48.8123 27.5002 50.375 29.4062 50.375H45.5938C47.4998 50.375 49.0625 48.8123 49.0625 46.9062V30.24L41.4475 22.625H29.4062ZM29.4062 24.9375H39.8125V31.875H46.75V46.9062C46.75 47.5566 46.2441 48.0625 45.5938 48.0625H29.4062C28.7559 48.0625 28.25 47.5566 28.25 46.9062V26.0938C28.25 25.4434 28.7559 24.9375 29.4062 24.9375ZM42.125 26.5725L45.115 29.5625H42.125V26.5725ZM32.875 36.5V38.8125H42.125V36.5H32.875ZM32.875 41.125V43.4375H39.8125V41.125H32.875Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoco);
export default __webpack_public_path__ + "static/media/doco.3a25f99d8ade8cfba360552ab372aeeb.svg";
export { ForwardRef as ReactComponent };